import BasePropertyView from 'BasePropertyView.js';
import util from 'util/Util.js';
import themeService from 'ThemeService.js';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class BasePropertyTableView extends BasePropertyView {

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    // Use for 'change input[type=text]    
    updateAttributes(ev) {
        if (!ev) {
            return;
        }
        ev.preventDefault();
        let propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldPropVal = this.columnModel.get(propName);

        propName = propName === 'customFontFamily' ? 'fontFamily' : propName === 'customTitleFontFamily' ? 'titleFontFamily' : propName === 'customButtonFontFamily' ? 'buttonFontFamily' : propName;
        this.columnModel.set(propName, propVal);

        this.render();

        // PF-5745
        undoService.add({
            undo: () =>{
                this.columnModel.set(propName, oldPropVal);
                this.render();
            },
            redo:() => {
                this.columnModel.set(propName, propVal);
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);

    }

    // Use for 'change input[type=text] which validates a text color
    updateColorAttributesWithValidation(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal);
            const oldPropVal = this.columnModel.get(propName);
            const oldColor = this.resolveColor(oldPropVal);

            this.columnModel.set(propName, color);
            this.render();

            // PF-5745
            undoService.add({
                undo: () =>{
                    this.columnModel.set(propName, oldColor);
                    this.render();  
                },
                redo:() => {
                    this.columnModel.set(propName, color);
                    this.render();
                }
            },textConstants.UNDO_PROP_CHANGE);

            return true;
        }

        // Call render if invalid color
        this.render();
        return false;
    }

    updateColorAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.id.replace('Picker', '');
        const propVal = ev.currentTarget.value;
        const oldPropVal = this.columnModel.get(propName);

        let color = this.resolveColor(propVal);
        const oldColor = this.resolveColor(oldPropVal);

        // Update model
        this.columnModel.set(propName, color);

        // Update text input
        $('#' + propName).val(color);
        this.render();

        // PF-5745
        undoService.add({
            undo: () =>{
                // Update model
                this.columnModel.set(propName, oldColor);

                // Update text input
                $('#' + propName).val(oldColor);
                this.render();
            },
            redo:() => {
                // Update model
                this.columnModel.set(propName, color);

                // Update text input
                $('#' + propName).val(color);
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);
    }
}

export default BasePropertyTableView;
